import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const BestOfAfrica = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Best Of Africa"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddBestOfAfrica = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Best Of Africa"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditBestOfAfrica = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Best Of Africa"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const ViewBestOfAfrica = () => {
  return (
    <DoSeeDataProvider>
      <Auth
        children={
          <Screen
            component={<Detail />}
            title="Best Of Africa Details"
          />
        }
      />
    </DoSeeDataProvider>
  );
};
